'use client';

import { usePathname } from 'next/navigation';
import { MouseEvent, useEffect, useState } from 'react';

export function useNavigationMenu(
  setActiveSection: (section: string) => void
) {
  const pathname = usePathname();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && menuOpen) {
        setMenuOpen(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [menuOpen]);

  const handleNavClick = (e: MouseEvent<HTMLAnchorElement>, href: string) => {
    setMenuOpen(false);
    document.body.style.overflow = '';

    if (pathname === '/' && href.startsWith('#')) {
      e.preventDefault();
      const targetId = href.substring(1);
      const elem = document.getElementById(targetId);

      if (elem) {
        setActiveSection(targetId);
        window.history.pushState(null, '', href);

        requestAnimationFrame(() => {
          elem.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }
  };

  return {
    pathname,
    menuOpen,
    setMenuOpen,
    handleNavClick,
  };
}
